var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 492,
    viewBox: "0 0 474 492",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M566.25 374.736C670.494 270.492 670.494 101.48 566.25 -2.76368C462.006 -107.007 292.994 -107.007 188.75 -2.76375C84.5063 101.48 84.5063 270.493 188.75 374.736C292.994 478.98 462.006 478.98 566.25 374.736Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M552.947 361.434C649.844 264.537 649.844 107.436 552.947 10.5387C456.049 -86.3584 298.948 -86.3584 202.051 10.5386C105.154 107.436 105.154 264.537 202.051 361.434C298.948 458.331 456.049 458.331 552.947 361.434Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.7273,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.51 415.292C504.154 415.292 606.82 312.627 606.82 185.982C606.82 59.3376 504.154 -43.3281 377.51 -43.3281C250.865 -43.3281 148.199 59.3376 148.199 185.982C148.199 312.627 250.865 415.292 377.51 415.292Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.9545,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 396.51C493.782 396.51 588.038 302.254 588.038 185.983C588.038 69.7121 493.782 -24.5439 377.511 -24.5439C261.24 -24.5439 166.984 69.7121 166.984 185.983C166.984 302.254 261.24 396.51 377.511 396.51Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.1818,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 377.697C483.392 377.697 569.225 291.864 569.225 185.983C569.225 80.102 483.392 -5.73145 377.511 -5.73145C271.63 -5.73145 185.797 80.102 185.797 185.983C185.797 291.864 271.63 377.697 377.511 377.697Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.4091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 358.884C473.002 358.884 550.413 281.474 550.413 185.983C550.413 90.4918 473.002 13.0811 377.511 13.0811C282.02 13.0811 204.609 90.4918 204.609 185.983C204.609 281.474 282.02 358.884 377.511 358.884Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.6364,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 340.072C462.612 340.072 531.6 271.084 531.6 185.983C531.6 100.882 462.612 31.8936 377.511 31.8936C292.41 31.8936 223.422 100.882 223.422 185.983C223.422 271.084 292.41 340.072 377.511 340.072Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 1.8636,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 321.259C452.222 321.259 512.787 260.694 512.787 185.983C512.787 111.272 452.222 50.7061 377.511 50.7061C302.8 50.7061 242.234 111.272 242.234 185.983C242.234 260.694 302.8 321.259 377.511 321.259Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.0909,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 302.447C441.832 302.447 493.975 250.304 493.975 185.983C493.975 121.661 441.832 69.5186 377.511 69.5186C313.19 69.5186 261.047 121.661 261.047 185.983C261.047 250.304 313.19 302.447 377.511 302.447Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.3182,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.511 283.634C431.442 283.634 475.162 239.914 475.162 185.983C475.162 132.051 431.442 88.3311 377.511 88.3311C323.579 88.3311 279.859 132.051 279.859 185.983C279.859 239.914 323.579 283.634 377.511 283.634Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.5454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.509 264.822C421.05 264.822 456.348 229.524 456.348 185.983C456.348 142.441 421.05 107.144 377.509 107.144C333.967 107.144 298.67 142.441 298.67 185.983C298.67 229.524 333.967 264.822 377.509 264.822Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2.7727,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M377.509 246.009C410.661 246.009 437.535 219.134 437.535 185.983C437.535 152.831 410.661 125.956 377.509 125.956C344.357 125.956 317.482 152.831 317.482 185.983C317.482 219.134 344.357 246.009 377.509 246.009Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.bf49eb0deef65a4a0b004af199fc0185.svg";
export { ForwardRef as ReactComponent };